import { useCallback, SyntheticEvent } from 'react'

import { useDispatch } from 'react-redux'

import { hideTooltipsAction, showTooltipAction } from 'actions/tooltipAction'

import { useShallowEqualSelector } from './useShallowEqualSelector'

export const useTooltip = (
  tooltipId: string
): [boolean, (event: SyntheticEvent) => void] => {
  const dispatch = useDispatch()

  const { tooltipState } = useShallowEqualSelector(
    ({ tooltipReducer: { tooltip } }) => ({
      tooltipState: tooltip[tooltipId],
    })
  )

  const toggleTooltipState = useCallback(
    (event?: SyntheticEvent) => {
      event?.stopPropagation()

      if (tooltipState) {
        dispatch(hideTooltipsAction())
      } else {
        dispatch(showTooltipAction(tooltipId))
      }
    },
    [dispatch, tooltipState, tooltipId]
  )

  return [tooltipState, toggleTooltipState]
}
